var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "#007bff",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M604.7,289.4H251.6c-19.4,0-35.1-15.7-35.1-35.1c0-19.4,15.7-35.1,35.1-35.1h353.1c19.4,0,35.1,15.7,35.1,35.1C639.8,273.7,624.1,289.4,604.7,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2,499.9H251.6c-19.4,0-35.1-15.7-35.1-35.1c0-19.4,15.7-35.1,35.1-35.1h210.5c19.4,0,35.1,15.7,35.1,35.1C497.3,484.2,481.5,499.9,462.2,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,955.2c0,19.2-15.6,34.8-34.8,34.8c-0.5,0-1.1,0-1.6,0c-25.7,0-248.3,0-248.3,0c-36.3,0-65.7-29.4-65.7-65.7V75.7C80.3,39.4,109.7,10,146,10h566.7c36.3,0,65.7,29.4,65.7,65.7l0,387.5c0,0.1,0,0.1,0,0.2c0,19.5-15.8,35.3-35.3,35.3c-19.5,0-35.3-15.8-35.3-35.3c0,0,0,0,0,0l0,0V78.5H149.8v841.9h246.7v0.1C415.4,920.8,430.7,936.3,430.7,955.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.2,637.5c-57.8,0-104.5,46.8-104.5,104.5s46.8,104.5,104.5,104.5c57.8,0,104.5-46.8,104.5-104.5S696.9,637.5,639.2,637.5z M639.2,777.3c-19.5,0-35.2-15.7-35.2-35.2c0-19.5,15.7-35.2,35.2-35.2c19.5,0,35.2,15.7,35.2,35.2C674.4,761.5,658.7,777.3,639.2,777.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.7,564.4C430.2,564.4,352,743.8,352,743.8s72.6,174.3,283.9,174.3c211.3,0,283.9-174.3,283.9-174.3S851.8,564.4,644.7,564.4z M635.3,847.6c-162.2,0-209.3-104.9-209.3-104.9s51.4-105.2,216-105.2c159,0,208.9,106.6,208.9,106.6S797.5,847.6,635.3,847.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit_icon.082a380130b4a4eba6242f22c36e9fc4.svg";
export { ForwardRef as ReactComponent };